var multi_step_form = {
    wp_nonce: null,
    endpoint: '/wp-json/syn/v1/validate-cf7-fields',
    nonce_endpoint: '/wp-json/syn/v1/get-nonce',
    validated_fields: {},
    to_validate: 'input[name],select[name],textarea[name]',
    current_page: 1,
    valid: false,
    get_nonce: async function (callback) {
        var url = this.nonce_endpoint;
        var request = jQuery.get(url, function (response) {
            if (
                typeof response.token != 'undefined'
                && response.token != ''
                && response.token != 'undefined'
                && response.token != null
            ) {
                multi_step_form.wp_nonce = response.token;
                if (typeof callback == 'function') {
                    callback();
                }
            }
        });
        return request;
    },
    disable_fields: function () {
        var $page = jQuery('.wpcf7 .form-page.active');
        var $fields = $page.find(this.to_validate);
        $fields.prop('disabled', true);
    },
    enable_fields: function () {
        var $page = jQuery('.wpcf7 .form-page.active');
        var $fields = $page.find(this.to_validate);
        $fields.prop('disabled', false);
    },
    get_input_object: function (selector) {
        return jQuery('input[name="' + selector + '"],select[name="' + selector + '"],textarea[name="' + selector + '"]');;
    },
    get_label: function ($field) {
        var label = $field.attr('placeholder');
        if ($field.attr('type') == 'date') {
            label = 'Date';
        }
        if (
            typeof label == 'undefined'
            || label == ''
            || label.length < 3
            || label == '$'
        ) {

            if ($field.prop('tagName') == 'SELECT') {
                var $option = $field.find('option');
                if ($option.length > 0) {
                    label = jQuery($option[0]).text();
                }
            } else {
                var $label = $field.closest('label');
                if ($label.length > 0) {
                    var check = $label.find('span.form-error');
                    if (check.length > 0) {
                        check.remove();
                    }
                    label = $label.text().replace(/\:/g, '').replace(/\*/g, '');
                }

            }
        }

        return label;
    },
    validate: function () {
        this.disable_fields();
        var $page = jQuery('.wpcf7 .form-page.active');
        var $fields = $page.find(this.to_validate);
        var values = [];
        $fields.each(function () {
            var $field = jQuery(this);

            var check = $field.closest('div[data-class="wpcf7cf_group"]');
            if (
                check.length > 0
                && check.hasClass('wpcf7cf-hidden')
            ) {
                return; //Hidden conditional fields are not validated or required.
            }


            var name = $field.attr('name');
            var value = $field.val();
            var type = $field.prop('type');
            if (
                $field.prop('tagName') == 'SELECT'
                || $field.prop('tagName') == 'TEXTAREA'
            ) {
                type = $field.prop('tagName').toLowerCase();
            }
            var required = false;
            if ($field.prop('required') == true) {
                required = true;
            }
            if (required == false) {
                var check = $field.attr('aria-required');
                if (check == 'true') {
                    required = true;
                }
            }

            var label = multi_step_form.get_label($field);

            var term_object = {
                name: name,
                value: value,
                type: type,
                required: required,
                label: label
            };
            values.push(term_object);
        });

        var url = this.endpoint + '?wp_nonce=' + this.wp_nonce;
        var params = {
            fields: values
        };

        $page.find('.form-error').remove();
        $page.find('.invalid').removeClass('invalid');

        var to_return = jQuery.post(url, params, function (response) {
            if (
                typeof response.error != 'undefined'
                && response.error == true
            ) {
                if (response.error == true) {

                    //console.log(response.errors);

                    for (var i in response.errors) {
                        var selector = i;
                        var error = response.errors[i];
                        $input = multi_step_form.get_input_object(selector);

                        $input.addClass('invalid');
                        jQuery('<span class="form-error">' + error + '</span>').insertAfter($input);
                    }
                    multi_step_form.valid = false;
                }
            } else {
                multi_step_form.valid = true;
            }
            multi_step_form.enable_fields();
            //console.log(response);
        }).fail(function(e){
            if(e.status == 400 || e.status == 403){
                multi_step_form.get_nonce(function(){
                    multi_step_form.validate();
                });
            }
        }).promise();

        return to_return;
    },
    nav_next: function () {
        jQuery('.wpcf7 .form-page button.form-nav-next').prop('disabled', true);
        jQuery('.wpcf7 .form-page button.form-nav-prev').prop('disabled', true);

        var promise = this.validate();

        promise.done(function () {
            jQuery('.wpcf7 .form-page button.form-nav-next').prop('disabled', false);
            jQuery('.wpcf7 .form-page button.form-nav-prev').prop('disabled', false);

            if (multi_step_form.valid == false) return;
            var cur = multi_step_form.current_page;
            var new_page = cur + 1;
            var $pages = jQuery('.wpcf7 .form-page');
            if (new_page > $pages.length) return;
            $page = jQuery('.wpcf7 .form-page[data-page="' + cur + '"]');
            $page.removeClass('active');
            $new_page = jQuery('.wpcf7 .form-page[data-page="' + new_page + '"]');
            $new_page.addClass('active');
            multi_step_form.current_page = new_page;
            if (multi_step_form.current_page == jQuery('.wpcf7 .form-page').length) {
                jQuery('.wpcf7 .form-page input[type="submit"').prop('disabled', false);
            }
            multi_step_form.scroll_to_heading();
        });


    },
    show_page: function (page) {
        var page = parseInt(page);
        var $pages = jQuery('.wpcf7 .form-page');
        if (page > $pages.length) return;
        $page = jQuery('.wpcf7 .form-page.active');
        $page.removeClass('active');
        $new_page = jQuery('.wpcf7 .form-page[data-page="' + page + '"]');
        this.current_page = page;
        if (this.current_page == jQuery('.wpcf7 .form-page').length) {
            jQuery('.wpcf7 .form-page input[type="submit"').prop('disabled', false);
        }
        $new_page.addClass('active');
    },
    nav_prev: function () {
        var cur = this.current_page;
        var new_page = cur - 1;
        if (new_page < 1) return;
        $page = jQuery('.wpcf7 .form-page[data-page="' + cur + '"]');
        $page.removeClass('active');
        $new_page = jQuery('.wpcf7 .form-page[data-page="' + new_page + '"]');
        $new_page.addClass('active');
        this.current_page = new_page;
        jQuery('.wpcf7 .form-page input[type="submit"').prop('disabled', true);
        this.scroll_to_heading();
    },
    scroll_to_heading: function () {
        jQuery('html,body').animate({
            scrollTop: jQuery('.application-form-wrap').offset().top - 60
        }, 500);
    },
    get_current_filename: function (dom) {
        var filename = dom.files[0].name;
        return filename;
    },
    clear_field: function (dom) {
        jQuery(dom).val('');
        jQuery(dom).trigger('change');
    },
    trigger_click: function (dom) {
        jQuery(dom).trigger('click');
    },
    slugify: function (text) {
        return text.toString().toLowerCase()
            .replace(/\s+/g, '-')           // Replace spaces with -
            .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
            .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    },
    bind: async function () {
        if (jQuery('.wpcf7 .form-page').length > 1) {
            jQuery('.wpcf7 .form-page input[type="submit"').prop('disabled', true);
            try {
                var nonce = await this.get_nonce();
            } catch (e) {
                //console.log(e);
            }
            jQuery('.wpcf7 .form-page').find('button.next-page').click(function () {
                multi_step_form.nav_next();
            });
            jQuery('.wpcf7 .form-page').find('button.prev-page').click(function () {
                multi_step_form.nav_prev();
            });
            jQuery('.wpcf7 .save-for-later').click(function () {
                jQuery.fn.getFormData = function () {
                    var data = {};
                    var dataArray = $(this).serializeArray();
                    for (var i = 0; i < dataArray.length; i++) {
                        data[dataArray[i].name] = dataArray[i].value;
                    }
                    return data;
                }
                var form_data = jQuery(this).closest('form').getFormData();
                var form_data = JSON.stringify(form_data);
                window.localStorage.setItem('application-form', form_data);
                jQuery('html,body').animate({
                    scrollTop: jQuery('h2').offset().top - 60
                }, 500);
                var $message = jQuery('<div class="full-screen-modal"><div class="modal-content"><h4>Saved</h4><p>Your application has been saved to your browser. Simply open this page again to continue.<br>(Click or Tap to Dismiss this Message).</p></div></div>');
                $message.on('click', function () {
                    jQuery(this).remove();
                });
                jQuery('body').append($message);
                jQuery('body .full-screen-modal').addClass('active');
            });
            var application_form = window.localStorage.getItem('application-form');
            if (application_form != '' && typeof application_form != 'undefined') {
                var form_data = JSON.parse(application_form);
                for (var i in form_data) {
                    var $item = jQuery('input[name="' + i + '"],select[name="' + i + '"]');
                    var type = $item.prop('type');
                    if (
                        type
                        && type != 'radio'
                        && type != 'input'
                    ) {
                        $item.val(form_data[i]);
                    } else if (
                        type == 'radio'
                        || type == 'input'
                    ) {
                        $item.prop('checked', false);
                        jQuery('input[name="' + i + '"][value="' + form_data[i] + '"]').prop('checked', true);
                    }

                }
            }
            jQuery('input[type="file"]').change(function () {
                var filename = multi_step_form.get_current_filename(this);
                var $parent = jQuery(this).closest('p');
                if (filename == '') {
                    filename = 'No File Chosen';
                }
                $parent.find('.file-upload-filename').html(filename);
            });
            jQuery('.file-upload-remove').click(function () {
                var $parent = jQuery(this).closest('p');
                var $input = $parent.find('input[type="file"]');
                multi_step_form.clear_field($input);
            });
            jQuery('.file-upload-button').click(function () {
                var $parent = jQuery(this).closest('p');
                var $input = $parent.find('input[type="file"]');
                multi_step_form.trigger_click($input);
            });
            var filename = 'No File Chosen';
            jQuery('p input[type="file"]').each(function () {
                var $parent = jQuery(this).closest('p');
                $parent.find('.file-upload-filename').html(filename);
            });
        }
    }
};

jQuery(document).ready(function () {
    multi_step_form.bind();
});

jQuery(document).ready(function () {
    // Add required to date fields next to radios
    jQuery('.should-require-datepicker input').on('change', function() {
        var value = jQuery(this).val();

        if (value == 'Yes') {
            jQuery(this).closest('.custom-form-row.row').find('input.wpcf7-form-control.wpcf7-date').attr('required', 'required');
        } else {
            jQuery(this).closest('.custom-form-row.row').find('input.wpcf7-form-control.wpcf7-date').removeAttr('required');
        }
    });
});